import { Modal, styled } from "@mui/material";
import { grey } from "../../../common/Theme/theme";

const UNLOCK_ESTATE_DISCOUNT_MODAL_PREFIX = "unlockEstateDiscountModal";

export const unlockEstateDiscountModalClasses = {
    root: `${UNLOCK_ESTATE_DISCOUNT_MODAL_PREFIX}-root`,
    paper: `${UNLOCK_ESTATE_DISCOUNT_MODAL_PREFIX}-paper`,
    acceptButton: `${UNLOCK_ESTATE_DISCOUNT_MODAL_PREFIX}-acceptButton`,
    description: `${UNLOCK_ESTATE_DISCOUNT_MODAL_PREFIX}-description`,
    modalTitle: `${UNLOCK_ESTATE_DISCOUNT_MODAL_PREFIX}-modalTitle`,
    price: `${UNLOCK_ESTATE_DISCOUNT_MODAL_PREFIX}-price`,
    icons: `${UNLOCK_ESTATE_DISCOUNT_MODAL_PREFIX}-icons`,
};
export const StyledUnlockEstateModal = styled(Modal)(({ theme }) => ({
    [`&.${unlockEstateDiscountModalClasses.root}`]: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
    },
    [`& .${unlockEstateDiscountModalClasses.paper}`]: {
        padding: "20px",
        width: "600px",
        display: "flex",
        "flex-direction": "column",
        "justify-content": "space-between",
        [theme.breakpoints.only("xs")]: {
            width: "320px",
            margin: "auto",
        },
    },
    [`& .${unlockEstateDiscountModalClasses.acceptButton}`]: {
        width: "200px",
        height: "40px",
        borderRadius: "100px",
        color: "white",
    },
    [`& .${unlockEstateDiscountModalClasses.description}`]: {
        color: grey,
        fontFamily: "Rubik",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "16px",
        [theme.breakpoints.only("xs")]: {
            fontSize: "14px",
        },
    },
    [`& .${unlockEstateDiscountModalClasses.modalTitle}`]: {
        fontFamily: "Rubik",
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "16px",
        paddingRight: "290px",
        [theme.breakpoints.only("xs")]: {
            fontSize: "14px",
            paddingRight: "50px",
        },
    },
    [`& .${unlockEstateDiscountModalClasses.price}`]: {
        fontFamily: "Rubik",
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "16px",
    },
    [`& .${unlockEstateDiscountModalClasses.icons}`]: {
        [theme.breakpoints.only("xs")]: {
            width: "15px",
        },
    },
}));
